export const pageList = [
  // Parent: Dashboard
  {
    name: 'Dashboard',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Data Source Summary',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Dashboard',
  },
  {
    name: 'Cross Source Summary',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Dashboard',
  },

  // Parent: Search
  {
    name: 'Search',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Investigate Visualizer',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Search',
  },

  // Parent: Graph
  {
    name: 'Graph',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Sync from opencorporates',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Graph',
  },
  {
    name: 'Force Merge',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Graph',
  },
  {
    name: 'Unmerge',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Graph',
  },

  // Parent: Reports
  {
    name: 'Reports',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Entity Resoultion',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Reports',
  },
  {
    name: 'Loans',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Reports',
  },

  // Parent: Setup
  {
    name: 'Setup',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Users',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Roles',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Permissions',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Upload Activity',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Sync Activity',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Flow Rules',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Data Loader',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  {
    name: 'Index Mapping',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Setup',
  },
  // Parent: Audit Log
  {
    name: 'Audit Log',
    enable: false,
    parent: true,
    hasChild: true,
  },

  // Parent: Screening
  {
    name: 'Screening',
    enable: false,
    parent: true,
    hasChild: true,
  },
  {
    name: 'Candidate Screening',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'VDD',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'VDD Onboarding',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Vendors',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Vendor Onboarding',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'ThirdParty',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'PDD',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Cash Cage',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Patrons List',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Employees',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Security',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Batch Screening',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Consumer Account Opening',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Commercial Account Opening',
    enable: false,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'ID Verification',
    enable: true,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
  {
    name: 'Assessment Order',
    enable: true,
    parent: false,
    hasChild: false,
    parentPage: 'Screening',
  },
];
